function escapeHtml(value = '') {
  return String(value).replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[character]);
}

function getStylesheets() {
  return [...document.querySelectorAll('link[rel="stylesheet"], style')]
    .map((element) => {
      if (element.tagName === 'LINK') {
        return `<link rel="stylesheet" href="${escapeHtml(element.href)}">`;
      }
      return `<style>${element.textContent}</style>`;
    })
    .join('');
}

export function printEventSection(element, title = 'Event production document') {
  if (!element || typeof window === 'undefined') return false;

  const printWindow = window.open('', '_blank');
  if (!printWindow) return false;

  printWindow.opener = null;
  const heading = escapeHtml(title);
  const content = element.outerHTML;

  printWindow.document.open();
  printWindow.document.write(`<!doctype html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>${heading}</title>
  ${getStylesheets()}
  <style>
    @page { margin: 16mm; }
    body.event-print-document { margin: 0; color: #17191e; background: #fff; font-family: "DM Sans", Arial, sans-serif; }
    .print-document-heading { margin: 0 0 22px; padding-bottom: 14px; border-bottom: 1px solid #dedbd3; }
    .print-document-heading small { color: #80683d; font-size: 9pt; font-weight: 700; letter-spacing: .12em; text-transform: uppercase; }
    .print-document-heading h1 { margin: 7px 0 0; font-size: 22pt; }
    .event-tab-print-content { width: 100%; }
    .print-only-notes { display: block !important; }
    @media print {
      body.event-print-document { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      .event-tab-print-content, .event-tab-print-content * { break-inside: auto; }
    }
  </style>
</head>
<body class="event-print-document">
  <header class="print-document-heading"><small>Angels Music Productions · Event Backstage</small><h1>${heading}</h1></header>
  ${content}
</body>
</html>`);
  printWindow.document.close();

  printWindow.addEventListener('afterprint', () => printWindow.close(), { once: true });
  window.setTimeout(async () => {
    if (printWindow.closed) return;
    try {
      await printWindow.document.fonts?.ready;
    } catch {
      // Use the available fallback font if the web font cannot load.
    }
    if (!printWindow.closed) {
      printWindow.focus();
      printWindow.print();
    }
  }, 450);

  return true;
}

export function printEventDocument(title = 'Event production document') {
  if (typeof window === 'undefined' || typeof window.print !== 'function') return false;

  const previousTitle = document.title;
  const restoreTitle = () => {
    document.title = previousTitle;
    window.removeEventListener('afterprint', restoreTitle);
  };

  document.title = title;
  window.addEventListener('afterprint', restoreTitle);
  window.requestAnimationFrame(() => window.setTimeout(() => window.print(), 150));
  return true;
}